export async function updateSetting(settingKey, settingValue) {
    try {
        const response = await fetch('/api/app-settings/update', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content, // Laravel CSRF
            },
            body: JSON.stringify({
                key: settingKey,
                value: settingValue,
            }),
        });


        const result = await response.json();
        if (result.success) {
            notify(result.message, 'green', 10000)
        } else {
            notify(result.message, 'red')
        }
        return result;
    } catch (error) {
        console.error('Error updating setting:', error);
    }
}
